import { mapActions, mapMutations, mapGetters } from 'vuex'
import { openWs, sendWS, messageWS, errorWS, initWS } from '../js/websockets'
import cookies from '../../../../utils/cookie'
import { handleRecogniseChoose } from '../js/help'
import { recognizeExamNo } from '../js/recognise'
import { clipImage } from '@/views/template-configuration/utils/js/clip'
const drawRect = {
	data() {
		return {
			//start x
			startX: 0,
			//start y
			startY: 0,
			//end x
			endX: 0,
			//end y
			endY: 0,
			//框完框子 的宽度
			rectWidth: 0,
			//的高度
			rectHeight: 0,
			//答题卡高度
			pageHeight: 0,
			//no use
			referNums: 0,
			//剪切的图片
			clipImg: '',
			query: this.$route.query,
			//当前答题卡的索引
			imgCurrentIndex: 0,
			//答题卡图片列表
			currentObjImgBox: [],
			//题型
			areaType: '',
			//no use
			concludeNum: 0,
			//ws key
			socketsKey: '',
			//ws 链接状态
			socketsState: false,
			//ws
			sockets: '',
			//no use
			changeScale: 1,
			//是否拖拽
			drawFlag: false,
			//画图 x 方向的最大位移
			prevAreaMaxX: 0,
			//画图 y 方向的最大位移
			prevAreaMaxY: 0
		}
	},
	watch: {
		//客观题
		async tempRectObjective(value) {
			let currentObj = []
			value.val.forEach(res => {
				if (this.imgCurrentIndex + 1 === Number(JSON.parse(res.remarks).page)) {
					currentObj.push(res)
				}
			})
			this.currentObjImgBox = currentObj
		},
		//切换题型
		tempReferTabState(val) {
			this.referRectDetail = { areaMinX: 0, areaMinY: 0, areaMaxX: 0, areaMaxY: 0 }
			if (val) this.setTempReferRectList([])
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'wsState',
			'tabActive',
			'tempSubList',
			'tempObjTopic',
			'tempScalePage',
			'tempExamNoType',
			'tempSelLikeSub',
			'tempSliceTopic',
			'tempEditImgInfo',
			'tempRectObjective',
			'tempReferTabState',
			'tempReferRectList',
			'tempSelLikeSubOrObj',
			'tempCurrentImgIndex',
			'tempSelLikeSubOrObjVal',
			'tempSelLikeSubOrObjName'
		])
	},
	created() {
		const _this = this
		this.sockets = initWS()
		openWs(this.sockets, () => (_this.socketsState = true))
		errorWS(this.sockets, () => (_this.socketsState = false))
	},
	mounted() {
		this.$nextTick(() => {
			this.drawRectList()
		})
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		...mapMutations('examination/configation', [
			'setTempClipImg',
			'setTempFlushData',
			'setHandHandleState',
			'setTempCurrentRefer',
			'setTempReferRectList',
			'setTempSelLikeSubOrObjVal',
			'setTempSelLikeSubOrObjName'
		]),
		// 	画图
		drawRectList() {
			const _this = this
			this.$refs['config'].onmousedown = function(event) {
				if (_this.tabActive === 'examNo') _this.examNoActiveIndex = null
				if (_this.tabActive === 'objective') _this.objectiveActiveIndex = []
				if (
					(_this.tabActive === 'objective' && _this.tempObjTopic.length === 0 && !_this.tempReferTabState) ||
					(_this.tabActive === 'subjective' && Object.keys(_this.tempSubList).length === 0) ||
					(_this.tabActive === 'slice' && Object.keys(_this.tempSliceTopic).length === 0) ||
					(_this.tabActive === 'choose' && _this.tempSelLikeSubOrObjName === '' && _this.tempSelLikeSub.length === 0)
				) {
					const type = { objective: '客观题', subjective: '主观题', choose: '选做题', slice: '原卷切块' }
					_this.$message.error(`请选择${type[_this.tabActive]}题号`)
					return false
				}
				if (event.button === 0 && !_this.drawFlag) {
					_this.drawFlag = true
					_this.prevAreaMaxX = event.offsetX
					_this.prevAreaMaxY = event.offsetY
					_this.startX = event.offsetX
					_this.startY = event.offsetY
					const newRect = {
						areaMinX: _this.startX,
						areaMinY: _this.startY,
						areaMaxX: _this.startX,
						areaMaxY: _this.startY,
						remarks: JSON.stringify({ page: _this.tempCurrentImgIndex.curIndex + 1, rote: '0' }),
						isShowChild: true
					}
					if (_this.tempReferTabState) {
						_this.referRectDetail = newRect
					} else {
						_this.rectDetail.push(newRect)
					}
					_this.$refs['config'].onmousemove = function(event) {
						if (_this.drawFlag && event.button === 0) {
							_this.endX = event.offsetX
							_this.endY = event.offsetY
							if (_this.tempReferTabState) {
								_this.referRectDetail['areaMaxX'] = _this.endX
								_this.referRectDetail['areaMaxY'] = _this.endY
							} else {
								let len = _this.rectDetail.length
								_this.$set(_this.rectDetail[len - 1], 'areaMaxX', _this.endX)
								_this.$set(_this.rectDetail[len - 1], 'areaMaxY', _this.endY)
							}
						}
					}
					_this.$refs['config'].onmouseup = function(event) {
						if (_this.drawFlag && event.button === 0) {
							if (event.stopPropagation) event.stopPropagation()
							if (event.preventDefault) event.preventDefault()
							event.cancelBubble = true
							event.returnValue = false
							_this.drawFlag = false
							let endX = event.offsetX < _this.endX ? _this.endX : event.offsetX
							let endY = event.offsetY < _this.endY ? _this.endY : event.offsetY
							_this.endX = endX
							_this.endY = endY
							const lens = _this.rectDetail?.length || 0
							if (_this.endX - _this.startX < 10 || _this.endY - _this.startY < 10) {
								if (_this.tempReferTabState) {
									_this.referRectDetail = { areaMinX: 0, areaMinY: 0, areaMaxX: 0, areaMaxY: 0 }
								} else {
									_this.$delete(_this.rectDetail, lens - 1)
								}
								return false
							}
							//  如果是参考模板 状态
							if (_this.tempReferTabState) {
								_this.referRectDetail['areaMaxX'] = _this.endX
								_this.referRectDetail['areaMaxY'] = _this.endY
								_this.clipRect(true)
								_this.referRectDetail = { areaMinX: 0, areaMinY: 0, areaMaxX: 0, areaMaxY: 0 }
							} else {
								const lens = _this.rectDetail.length
								_this.rectDetail[lens - 1].areaMaxX = _this.endX
								_this.rectDetail[lens - 1].areaMaxY = _this.endY
								_this.handleDrawedData()
							}
						}
						return false
					}
				}
			}
		},
		//画完图  操作数据
		handleDrawedData() {
			let state = false
			if (this.tempReferTabState) state = true
			if (this.tabActive === 'objective') {
				this.clipRect(state)
			} else if (this.tabActive === 'examNo' && this.tempExamNoType === 1) {
				this.clipRect(state)
			} else if (this.tabActive === 'examNo' && this.tempExamNoType === 3) {
				this.addDropRect(this.endX, this.endY, this.startX, this.startY)
			} else if (this.tabActive === 'title' || this.tabActive === 'subjective' || this.tabActive === 'lack' || this.tabActive === 'slice') {
				this.addDropRect(this.endX, this.endY, this.startX, this.startY)
			} else if (this.tabActive === 'choose') {
				// 如果是选做题  类似 主观体
				if (this.tempSelLikeSubOrObj === 'sub') {
					const _this = this
					this.tempSelLikeSub.forEach(res => {
						setTimeout(() => {
							_this.setTempSelLikeSubOrObjName(res.name)
							_this.setTempSelLikeSubOrObjVal(res)
							_this.addDropRect(_this.endX, _this.endY, _this.startX, _this.startY)
						}, 300)
					})
				} else if (this.tempSelLikeSubOrObj === 'obj' && !this.socketsState) {
					//客观题 手动配置情况下
					this.addDropRect(this.endX, this.endY, this.startX, this.startY)
				} else if (this.tempSelLikeSubOrObj === 'obj' && this.socketsState) {
					//客观题 有客户端的情况下
					this.clipRect(state)
				}
			}
		},

		// 图片剪切  flag: 是否参考模板
		clipRect(flag) {
			const _this = this
			const pos = {
				startX: this.startX,
				startY: this.startY,
				endX: this.endX,
				endY: this.endY
			}
			clipImage(pos, this.currentImg, function(img) {
				_this.clipImg = img
				if (_this.socketsState === false && !_this.tempReferTabState) {
					if (_this.tabActive === 'objective' || (_this.tabActive === 'examNo' && !_this.isDragRect)) {
						_this.setHandHandleState(true)
					}
					return false
				}
				if (flag) {
					// 参考模板的情况和下
					_this.setTempCurrentRefer({ base64Img: _this.clipImg, image: _this.currentImg, pos })
				} else {
					_this.operateRect(pos.startX, pos.startY, pos.endX - pos.startX, pos.endY - pos.startY)
				}
			})
		},
		operateRect(startX, startY, rectWidth, rectHeight) {
			const _this = this
			if (_this.emitType === 'tempRectObjective') {
				_this.eventBus.$emit(_this.emitType, { val: _this.rectDetail, state: true })
			} else {
				_this.eventBus.$emit(_this.emitType, _this.rectDetail)
			}
			let opt = ''
			if (_this.tabActive === 'examNo') {
				opt = 'kh'
				if (this.tempReferRectList.length) opt = 'kh_temp'
			}
			if (_this.tabActive === 'objective') {
				opt = 'kgt'
				if (this.tempReferRectList.length) opt = 'kgt_temp'
			}
			if (_this.tabActive === 'choose') opt = 'kgt'
			_this.recogniseRect(startX, startY, rectWidth, rectHeight, opt)
		},
		// 识别 新增识别  可会断识别
		async recogniseRect(startX, startY, rectWidth, rectHeight, opt) {
			const _this = this
			const params = {
				rect: {
					x: startX,
					y: startY,
					w: rectWidth,
					h: rectHeight
				},
				rotate: 0,
				examId: this.query.examId,
				cvvId: this.tempEditImgInfo.versionId,
				opt,
				argv: { bw: 48, bh: 35 },
				bs: this.clipImg.match(/base64,(.*)/)[1]
			}
			if (this.tempReferRectList.length > 0) {
				let temps = []
				let pos = this.tempReferRectList[0].pos
				params.argv.bw = pos.endX - pos.startX
				params.argv.bh = pos.endY - pos.startY
				this.tempReferRectList.forEach(res => {
					temps.push(res.image.match(/base64,(.*)/)[1])
				})
				params.argv.temps = temps
			}
			const socketsKey = cookies.get('socketsKey')
			await sendWS(this.sockets, socketsKey, params)
			await messageWS(this.sockets, async function(v) {
				if (_this.tabActive === 'examNo') {
					// 识别考号
					recognizeExamNo(_this, v.resp.rbox, [_this.endX, _this.endY, _this.startX, _this.startY])
				} else if (_this.tabActive === 'choose') {
					// 识别主观题
					_this.recogniseChoose(v.resp.rbox)
				} else if (_this.tabActive === 'objective') {
					let objLen = 0,
						boxLen = 0,
						box = []
					if (_this.tempObjTopic.length === 0) {
						_this.$message.error('请选择题块')
						return false
					}
					_this.tempObjTopic.forEach(res => res.val.forEach(resp => (objLen += resp.num)))
					_this.currentObjImgBox.forEach(ele => {
						if (ele?.appendInfo) boxLen += JSON.parse(ele.appendInfo).box.length
					})
					if (v.resp.rbox) {
						boxLen += v.resp.rbox.length
						v.resp.rbox.forEach(res => {
							box.push({ c: res.C, h: res.H, i: res.I, r: res.R, w: res.W, x: res.X, y: res.Y, m: '', n: '' })
						})
					}
					_this.addDropRect(_this.endX, _this.endY, _this.startX, _this.startY, box).then(() => {
						if (objLen === boxLen) {
							import('../js/help').then(res => {
								console.log(res)
							})
						}
					})
				}
			})
		},
		// 识别考号
		async recognizeExamNo(val, isFresh = false) {
			let box = []
			if (val.length > 0) {
				let setaVal = []
				val.forEach(resp => {
					setaVal.push({
						c: resp.C || resp.c,
						h: resp.H || resp.h,
						i: resp.I || resp.i,
						r: resp.R || resp.r,
						w: resp.W || resp.w,
						x: resp.X || resp.x,
						y: resp.Y || resp.y,
						v: resp.v
					})
				})
				if (setaVal.length % 10 !== 0) {
					this.addDropRect(this.endX, this.endY, this.startX, this.startY, setaVal)
					return false
				}
				let yArr = []
				setaVal.forEach(res => yArr.push(res.y))
				let yMin = Math.min(...yArr)
				let yMax = Math.max(...yArr)
				let height = setaVal[0].h
				let yInterval = (yMax - yMin - height * 8) / 9
				let heightInterval = (yMax - yMin + yInterval + height) / 10
				let yHeightList = []
				for (var i = 0; i < 10; i++) {
					yHeightList.push(Math.round(heightInterval * (i + 1) + height))
				}
				yHeightList.unshift(0)
				let intervalH = height
				let listObj = {}
				for (let i = 0; i < 10; i++) {
					setaVal.forEach(res => {
						if (res.y >= yHeightList[i] - intervalH && res.y <= yHeightList[i + 1] - intervalH) {
							if (!listObj[yHeightList[i]]) listObj[yHeightList[i]] = []
							listObj[yHeightList[i]].push(Object.assign({}, res, { v: i }))
						}
					})
				}
				box = Object.values(listObj).flat(Infinity)
			}
			if (isFresh) {
				return box
			} else {
				this.addDropRect(this.endX, this.endY, this.startX, this.startY, box)
			}
		},
		// 选做题识别  类选择题
		recogniseChoose(val) {
			if (this.tempSelLikeSubOrObjVal.length === 0) {
				this.$message({ type: 'error', message: '请选择选做题题号', duration: 3000 })
				return false
			}
			let box = []
			if (val) {
				val.forEach(res => {
					box.push({
						c: res.C || res.c,
						h: res.H || res.h,
						i: res.I || res.i,
						r: res.R || res.r,
						w: res.W || res.w,
						x: res.X || res.x,
						y: res.Y || res.y
					})
				})
			}
			if (this.tempSelLikeSubOrObjVal.length !== box.length) {
				this.addDropRect(this.endX, this.endY, this.startX, this.startY, box)
			}
			if (this.tempSelLikeSubOrObjVal.length === box.length) {
				handleRecogniseChoose(box, this.tempSelLikeSubOrObjVal).then(res => {
					this.addDropRect(this.endX, this.endY, this.startX, this.startY, res)
				})
			}
		}
	}
}
export default drawRect
